import Lib from '../../../commons/lib';

export default class Service {
  static bizonylatUrl = window.location.origin + '/api/bizonylat/';

  static raktarUrl = window.location.origin + '/api/raktar/';

  // BIZONYLATTÍPUS START

  static listBizonylattipus(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bizonylatUrl + 'biztipus/list',
      args: { requestType: 'bizonylat-biztipus-list' }
    }], fnDone);
  }

  static listBizonylattipusEnums(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bizonylatUrl + 'biztipus/enum',
      args: { requestType: 'bizonylat-biztipus-enum' }
    }], fnDone);
  }

  static createBizonylattipus(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bizonylatUrl + 'biztipus',
      args: { requestType: 'bizonylat-create' },
      data: data,
    }], fnDone);
  }

  static updateBizonylattipus(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bizonylatUrl + 'biztipus',
      args: { requestType: 'bizonylat-update' },
      data: data,
    }], fnDone);
  }

  static deleteBizonylattipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.bizonylatUrl + 'biztipus',
      args: { requestType: 'bizonylat-delete' },
      params: { id: id },
    }], fnDone);
  }

  // BIZONYLATTÍPUS END

  // BIZONYLATTÖMB START

  static listBizonylattomb(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bizonylatUrl + 'biztomb/list',
      args: { requestType: 'bizonylat-biztomb-list' }
    }], fnDone);
  }

  static listBizonylattombEnums(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bizonylatUrl + 'biztomb/enum',
      args: { requestType: 'bizonylat-biztomb-enum' }
    }], fnDone);
  }

  static listAktivBizonylattipus(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bizonylatUrl + 'biztipus/aktiv',
      args: { requestType: 'bizonylat-biztipus-aktiv' }
    }], fnDone);
  }

  static listAktivRaktar(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.raktarUrl + 'raktar/aktiv',
      args: { requestType: 'raktar-aktiv-list' }
    }], fnDone);
  }

  static lockBizonylattomb(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bizonylatUrl + 'biztomb/lezar',
      args: { requestType: 'biztomb-lezar' },
      params: { id: id }
    }], fnDone);
  }

  static createBizonylattomb(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bizonylatUrl + 'biztomb',
      args: { requestType: 'bizonylat-create' },
      data: data,
    }], fnDone);
  }

  static updateBizonylattomb(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bizonylatUrl + 'biztomb',
      args: { requestType: 'bizonylat-update' },
      data: data,
    }], fnDone);
  }

  static deleteBizonylattomb(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.bizonylatUrl + 'biztomb',
      args: { requestType: 'bizonylat-delete' },
      params: { id: id },
    }], fnDone);
  }

  static existsRaktar(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bizonylatUrl + 'exists/raktar',
      args: { requestType: 'exists-raktar' },
    }], fnDone);
  }

  // BIZONYLATTÖMB END
}
